import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState, UserLogin } from 'ngx-sds-login';
import { Observable, Subject, takeUntil } from 'rxjs';
import { Solicitud } from 'src/app/infraestructure/interfaces/referente/SolicitudDTO';
import { ProgrammerApiService } from 'src/app/infraestructure/services/programmer/programmer-api.service';
import { ReferentApiService } from 'src/app/infraestructure/services/referent/referent-api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-table-consult-request-programmer',
  templateUrl: './table-consult-request-programmer.component.html',
  styleUrls: ['./table-consult-request-programmer.component.scss']
})
export class TableConsultRequestProgrammerComponent implements OnInit, OnChanges {
  
  @Input() dataTable: Solicitud  = new Solicitud();

  @Input() actions: boolean = false;

  private $topSubcription = new Subject<void>();
  solicitud: Solicitud = new Solicitud();
  idSolicitud: any = null;
  idSolicitudRelacionada: any = null;
  user$: Observable<UserLogin>;
  userId: number = 0;
  
  constructor(private referentApiSrv: ReferentApiService,
              private programerApiSrv: ProgrammerApiService,
              private store: Store<AppState>,
              private route: ActivatedRoute,
              private router: Router) {
                this.user$ = this.store.select(state => state.user);
                this.user$.subscribe(user => {
                  this.userId = user.id;
                });
              }
  
  ngOnInit(): void {
    this.idSolicitud = Number(this.route.snapshot.paramMap.get('id'))
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dataTable'] && this.dataTable.id) {
      this.solicitud = this.dataTable;
    }
  }

  onSearchRequest() {
    if (!this.idSolicitudRelacionada) return;
    this.referentApiSrv.getSolicitudById(this.idSolicitudRelacionada)
      .pipe(takeUntil(this.$topSubcription))
      .subscribe(res => {
        if (res.code === 200) {
          this.solicitud = res.data;
        } else {
          this.solicitud = new Solicitud();
        }
      });
  }

  onRelate() {
    if (this.solicitud.id && this.idSolicitud) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: "<h5 style='color:#f8bb86'>" + 'Advertencia' + "</h5>",
        text: `Esta seguro de de vincular las solicitudes de servicio seleccionadas`,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonColor: "#2BA3BF",
        confirmButtonText: "ACEPTAR",
        cancelButtonText: "CANCELAR"
      }).then(confirm => {
        if (confirm.isConfirmed) {
          let request = {"solicitudPrincipalId": this.idSolicitud, "solicitudSecundariaId": Number(this.idSolicitudRelacionada), usuarioId: Number(this.userId)}
          
          this.programerApiSrv.postSolicitudRelacionada(request)
          .pipe(takeUntil(this.$topSubcription))
          .subscribe(res => {
            if (res.code === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: `Vinculación exitosa`,
                text: `Se ha generado la unificación de las solicitudes con el Id ${res.data.solicitudClonadaId}`,
                showConfirmButton: true,
                confirmButtonColor: "#004884",
                confirmButtonText: "ACEPTAR",
              }).then(() => {
                const currentUrl = `/gestion-solicitud-programador/${res.data.solicitudClonadaId}`;
                this.router.navigate([currentUrl]);

                this.idSolicitudRelacionada = null;
                this.solicitud = new Solicitud();
              });
            } else {
              const messages = res.errors.map((error: any) => `<li>${error.message}</li>`).join('\n');
              
              Swal.fire({
                title: 'Errores',
                icon: 'error',
                html: '<ul style="text-align: left; font-size: 0.8rem;">' + messages + '</ul>',
                showConfirmButton: true,
                confirmButtonColor: "#004884",
                confirmButtonText: "ACEPTAR",
              });
            }
          });
        }
      });
    }
  }
}